import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { style: {"text-align":"center"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Image not found! :( ")
const _hoisted_3 = {
  key: 0,
  class: "pt-2"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Token: ")
const _hoisted_5 = ["href"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "pt-2 row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex xs4" }, "Status:", -1)
const _hoisted_9 = {
  key: 0,
  class: "flex xs8"
}
const _hoisted_10 = {
  key: 1,
  class: "flex xs8"
}
const _hoisted_11 = { key: 2 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Positions: ")
const _hoisted_13 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("strong", null, "None Found", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { key: 4 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Level:")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Select")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Vote")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Subscribe")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Claim")

import { computed, onMounted, ref, watchEffect } from "vue";
import Moralis from "moralis";
import { Protocol } from "@/models/Protocol";
import ProtocolClaim from "./ProtocolClaim.vue";
import PositionListItem from "./PositionListItem.vue";
import { Position } from "@/models/Position";
import { getCurrentInstance } from "vue";
import { roundToTwo, prettyNumber } from "@/Utilities";

/* global defineProps, defineEmits */

export default /*#__PURE__*/_defineComponent({
  props: {
  showVote: { type: Boolean, required: false, default: false },
  showSubscribe: { type: Boolean, required: false, default: false },
  showUserInfo: { type: Boolean, required: false, default: false },
  showPositions: { type: Boolean, required: false, default: false },
  showFavorites: { type: Boolean, required: false, default: true },
  allowSelect: { type: Boolean, required: false, default: true },
  displayMode: { type: String, required: false, default: "wide" },
  manager: { type: Boolean, required: false, default: false },
  protocol: { type: Protocol, required: true },
  selected: { type: Boolean, required: false, default: false },
},
  emits: ["selected", "subscribe", "claimed"],
  setup(__props, { emit }) {

const props = __props




const showClaim = ref(false);

const isFavorite = ref(false);
const refreshFavorite = async () => {
  isFavorite.value = await props.protocol.isFavorite();
};

watchEffect(() => {
  if (props.protocol != undefined && props.showFavorites) {
    refreshFavorite();
  }
});

const toggleFavorite = async (): Promise<void> => {
  await props.protocol.toggleFavorite();
  refreshFavorite();
};

const positions = ref<Position[]>([]);
const loadingPositions = ref(false);
const showNoPositions = computed((): boolean => {
  return !loadingPositions.value && positions.value.length == 0;
});

const wide = computed(() => {
  return props.displayMode == "wide";
});

const cardClass = computed((): Record<string, boolean> => {
  if (wide.value)
    return {
      active: props.selected,
      flex: true,
      "mb-1": true,
      xs12: wide.value,
      sm6: wide.value,
      lg6: wide.value,
      xl6: wide.value,
    };
  else
    return {
      active: props.selected,
      flex: true,
      "mb-1": true,
      xs12: !wide.value,
      sm4: !wide.value,
      lg3: !wide.value,
      xl2: !wide.value,
    };
});

onMounted(async () => {
  if (props.showPositions) {
    fetchPositions();
  }
  if (props.showFavorites) {
    refreshFavorite();
  }
});

const fetchPositions = async (refresh?: boolean) => {
  loadingPositions.value = true;
  positions.value = await props.protocol.positions(refresh);
  loadingPositions.value = false;
};

const protocolValue = computed(() => {
  let total = 0;
  positions.value.forEach((p: any) => {
    total = total + p.value;
  });
  return roundToTwo(total);
});

const allowSelectHref = computed(() => {
  return props.allowSelect ? "#" : null;
});

const voteFor = async (aProtocol: Protocol): Promise<void> => {
  const newVotes = await aProtocol.siteVote();
  const instance = getCurrentInstance();
  instance?.proxy?.$forceUpdate();
};

const claim = (aProtocol: Protocol): void => {
  showClaim.value = true;
};

const claimSaved = (aProtocolStatus: any): void => {
  showClaim.value = false;
  emit("claimed", aProtocolStatus);
};

const select = (aProtocol: Protocol): void => {
  if (props.allowSelect) {
    emit("selected", aProtocol);
  }
};
const subscribe = (aProtocol: Protocol): void => {
  emit("subscribe", aProtocol);
};

return (_ctx: any,_cache: any) => {
  const _component_va_chip = _resolveComponent("va-chip")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_card_title = _resolveComponent("va-card-title")!
  const _component_va_progress_circle = _resolveComponent("va-progress-circle")!
  const _component_va_image = _resolveComponent("va-image")!
  const _component_va_badge = _resolveComponent("va-badge")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_list_label = _resolveComponent("va-list-label")!
  const _component_va_avatar = _resolveComponent("va-avatar")!
  const _component_va_list_item_section = _resolveComponent("va-list-item-section")!
  const _component_va_list_item_label = _resolveComponent("va-list-item-label")!
  const _component_va_list_item = _resolveComponent("va-list-item")!
  const _component_va_list_separator = _resolveComponent("va-list-separator")!
  const _component_va_inner_loading = _resolveComponent("va-inner-loading")!
  const _component_va_list = _resolveComponent("va-list")!
  const _component_va_popover = _resolveComponent("va-popover")!
  const _component_va_card_actions = _resolveComponent("va-card-actions")!
  const _component_va_card = _resolveComponent("va-card")!
  const _component_va_modal = _resolveComponent("va-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_va_card, {
      class: _normalizeClass(_unref(cardClass)),
      dark: __props.selected,
      stripe: __props.selected,
      "stripe-color": "success",
      href: _unref(allowSelectHref),
      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (select(__props.protocol)), ["prevent"]))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_va_card_title, null, {
          default: _withCtx(() => [
            _createVNode(_component_va_chip, {
              href: __props.protocol.website,
              shadow: "",
              color: "success",
              size: "medium"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_1, _toDisplayString(__props.protocol.name), 1)
              ]),
              _: 1
            }, 8, ["href"]),
            (__props.showFavorites)
              ? (_openBlock(), _createBlock(_component_va_icon, {
                  key: 0,
                  name: isFavorite.value ? 'favorite' : 'favorite_border',
                  size: 35,
                  onClick: toggleFavorite,
                  color: isFavorite.value ? 'danger' : '#000'
                }, null, 8, ["name", "color"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_va_image, {
          style: {"height":"50px"},
          contain: "",
          src: __props.protocol.iconURL
        }, {
          error: _withCtx(() => [
            _hoisted_2
          ]),
          loader: _withCtx(() => [
            _createVNode(_component_va_progress_circle, { indeterminate: "" })
          ]),
          _: 1
        }, 8, ["src"]),
        (__props.protocol.tokenData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("a", {
                href: __props.protocol.tokenContractURL(),
                target: "_blank"
              }, _toDisplayString(__props.protocol.tokenData.symbol), 9, _hoisted_5)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _renderSlot(_ctx.$slots, "details", { protocol: __props.protocol })
        ]),
        (__props.showVote)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                (__props.protocol.protocolSiteStatus == 'Pending')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_va_badge, {
                        "visible-empty": "",
                        ref: "badge",
                        text: __props.protocol.protocolPendingVotes,
                        class: "mr-4"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.protocol.protocolSiteStatus), 1)
                        ]),
                        _: 1
                      }, 8, ["text"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(__props.protocol.protocolSiteStatus), 1))
              ])
            ]))
          : _createCommentVNode("", true),
        (__props.showPositions)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_va_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_va_list_label, null, {
                    default: _withCtx(() => [
                      _hoisted_12,
                      _createVNode(_component_va_button, {
                        class: "float-right",
                        icon: "refresh",
                        size: "small",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (fetchPositions(true)))
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_va_inner_loading, { loading: loadingPositions.value }, {
                    default: _withCtx(() => [
                      _createVNode(_component_va_list_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_va_list_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_va_avatar, {
                                src: __props.protocol.iconURL,
                                size: 25
                              }, null, 8, ["src"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_va_list_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_va_list_item_label, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_va_icon, {
                                    name: "workspaces",
                                    size: 16
                                  }),
                                  _createTextVNode(" Protocol Total $" + _toDisplayString(_unref(prettyNumber)(_unref(protocolValue))), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_va_list_separator),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(positions.value, (position, idx) => {
                        return (_openBlock(), _createBlock(PositionListItem, {
                          key: idx,
                          position: position
                        }, null, 8, ["position"]))
                      }), 128)),
                      (_unref(showNoPositions))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (__props.showUserInfo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, "Balance: " + _toDisplayString(__props.protocol.getWalletBalance()), 1))
          : _createCommentVNode("", true),
        (__props.showUserInfo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("strong", null, _toDisplayString(__props.protocol.getUserLevel()), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_va_card_actions, null, {
          default: _withCtx(() => [
            (__props.allowSelect)
              ? (_openBlock(), _createBlock(_component_va_button, {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (select(__props.protocol)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_va_popover, {
              color: "primary",
              message: "Request support for this Protocol on Notifi"
            }, {
              default: _withCtx(() => [
                (__props.showVote && __props.protocol.protocolSiteStatus == 'Pending')
                  ? (_openBlock(), _createBlock(_component_va_button, {
                      key: 0,
                      size: "small",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (voteFor(__props.protocol)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_20
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (__props.showSubscribe && __props.protocol.protocolSiteStatus == 'Active')
              ? (_openBlock(), _createBlock(_component_va_button, {
                  key: 1,
                  size: "small",
                  color: "primary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (subscribe(__props.protocol)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_21
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (__props.showVote && __props.protocol.protocolSiteStatus == 'Pending')
              ? (_openBlock(), _createBlock(_component_va_button, {
                  key: 2,
                  size: "small",
                  color: "warning",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (claim(__props.protocol)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_22
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 3
    }, 8, ["class", "dark", "stripe", "href"]),
    _createVNode(_component_va_modal, {
      modelValue: showClaim.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showClaim).value = $event)),
      title: "",
      "hide-default-actions": ""
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createVNode(ProtocolClaim, {
            protocol: __props.protocol,
            onSaved: claimSaved
          }, null, 8, ["protocol"])
        ])
      ]),
      _: 3
    }, 8, ["modelValue"])
  ], 64))
}
}

})